// RUTA: src/components/ExpandingCard/cardData.ts

import { ReactComponent as ProductsIcon } from '../../assets/icons/producto.svg';
import { ReactComponent as GeneralIcon } from '../../assets/icons/general.svg';
import { ReactComponent as ColoresICon } from '../../assets/icons/colores.svg';
import { ReactComponent as CilindroIcon } from '../../assets/icons/cilindro.svg';

// Tipo para los sub-elementos
export interface SubItem {
  name: string;
  path: string;
}

// Tipo para la información de cada tarjeta
export interface CardInfo {
  id: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  path?: string;
  subItems?: SubItem[];
}

// Array con los datos de las tarjetas que se mostrarán
export const cardData: CardInfo[] = [
  {
    id: 'productos',
    icon: ProductsIcon,
    title: 'Productos',
    subItems: [
      { name: 'Productos', path: '/catalogos/productos' },
    ],
    path: '/catalogos/productos',
  },
  {
    id: 'general',
    icon: GeneralIcon,
    title: 'General',
    //path: '/maestro-envases/productos',
    subItems: [
      { name: 'Sucursal', path: '/catalogos/sucursales' },
      { name: 'Fabricante', path: '/catalogos/fabricante' },
      { name: 'Modelo', path: '/catalogos/modelo' },
      { name: 'Tipo envase', path: '/catalogos/tipo-envase' },

    ]
  },
  {
    id: 'catalogos',
    icon: ColoresICon,
    title: 'Colores',
    //path: '/catalogos', // Ruta de fallback
    // Sí tiene 'subItems', por lo tanto, se expandirá con el hover.
    subItems: [
      { name: 'Válvula', path: '/catalogos/valvula' },
      { name: 'Cuerpo', path: '/catalogos/cat-cuerpo' },
      { name: 'Capuchon', path: '/catalogos/cat-capuchones' },
      { name: 'Cuello', path: '/catalogos/cat-cuello' },
      { name: 'Estarcido', path: '/catalogos/cat-estarcido' },
      { name: 'Ojiva', path: '/catalogos/cat-ojiva' },
    ],
  },
  {
    id: 'manifold',
    icon: CilindroIcon,
    title: 'Manifold',
    subItems: [
      { name: 'Configuración Manifold', path: '/catalogos/manifold' },
      { name: 'Línea', path: '/catalogos/linea' },
    ],
  },
];